var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ql-container ql-snow"},[_c('p',{staticClass:"legalContent ql-editor",domProps:{"innerHTML":_vm._s(_vm.pageInfo)}})])}
var staticRenderFns = []

export { render, staticRenderFns }